import { getRawLocalStorageItem, setRawLocalStorageItem } from 'src/services/storage/local';
import { isNil } from 'src/utils/typeguards/isNil';
import { FrequencyTrackedEvent, FREQUENCY_TRACKING_PREFIX } from './constants';

export const trackFrequency = (event: FrequencyTrackedEvent) => {
    const EVENT_KEY = `${FREQUENCY_TRACKING_PREFIX}.${event}`;
    const currentInstanceTimestamp = new Date().getTime();
    const lastInstanceTimestampAsString = getRawLocalStorageItem(EVENT_KEY);
    if (isNil(lastInstanceTimestampAsString)) {
        setRawLocalStorageItem(EVENT_KEY, String(currentInstanceTimestamp));
        // it's been forever since the last instance
        return Number.POSITIVE_INFINITY;
    }
    const lastInstanceTimestamp = new Date(Number(lastInstanceTimestampAsString)).getTime();
    const timeSinceLastInstance = currentInstanceTimestamp - lastInstanceTimestamp;
    setRawLocalStorageItem(EVENT_KEY, String(currentInstanceTimestamp));
    return timeSinceLastInstance;
};
